export enum EnvName {
  Prod = 'production',
  Test = 'testing',
  Dev = 'development',
  Local = 'local',
}
